import React from 'react';
import { styled } from '@compiled/react';
import dateFormat from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { convertISODateFormat } from '@atlassian/jira-compatibility';
import { FormattedRelativeV2 as FormattedRelative } from '@atlassian/jira-intl/src/v2/formatted-relative.tsx';
import { TOOLTIP_DATE_FORMAT } from './constants';
import { getDueDays } from './utils';

const Expiry = ({ value }: { value: string }) => {
	const retentionTillDate = convertISODateFormat(value);
	const dueDays = getDueDays(retentionTillDate);
	const parsedDate = isValid(parseISO(retentionTillDate))
		? parseISO(retentionTillDate)
		: new Date(retentionTillDate);
	return (
		<BlockContainer>
			<Tooltip content={dateFormat(parsedDate, TOOLTIP_DATE_FORMAT)} position="top">
				<FormattedRelative value={retentionTillDate} units="day">
					{(formattedDate) => (
						<CapitalizeContainer>
							<ExpiryDateContainer dueInWeek={dueDays <= 7}>{formattedDate}</ExpiryDateContainer>
						</CapitalizeContainer>
					)}
				</FormattedRelative>
			</Tooltip>
		</BlockContainer>
	);
};

export default Expiry;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const CapitalizeContainer = styled.div({
	display: 'inline-block',
	'&::first-letter': {
		textTransform: 'uppercase',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const BlockContainer = styled.div({
	display: 'block',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const ExpiryDateContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ dueInWeek }: { dueInWeek?: boolean }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		dueInWeek ? token('color.text.danger', colors.R400) : 'inherit',
});

ExpiryDateContainer.displayName = 'ExpiryDateContainer';
